/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */
import React from 'react'

import { FiAlertTriangle } from 'react-icons/fi'

import AssetTableCell from './AssetTableCell'

import { Severity } from '../types'

type AssetSeverityIconProps = {
  severity: Severity | null
}

const renderSeverityIcon = (severity: Severity | null) => {
  const iconSize = 'w-4 h-4'

  switch (severity) {
    case 'critical':
      return <FiAlertTriangle className={`${iconSize} text-red-500`} />
    case 'warning':
      return <FiAlertTriangle className={`${iconSize} text-yellow-500`} />
    case 'informational':
      return <FiAlertTriangle className={`${iconSize} text-green-500`} />
    default:
      return <></>
  }
}

/** The triangle in the severity's colour; nothing for no severity. */
export const SeverityIcon = ({ severity }: { severity: Severity | null }) => renderSeverityIcon(severity)

const AssetSeverityIcon: React.FC<AssetSeverityIconProps> = ({ severity }) => {
  return (
    <AssetTableCell tooltip={severity?.toString()}>
      <div className="w-full h-full flex items-center justify-center">{renderSeverityIcon(severity)}</div>
    </AssetTableCell>
  )
}

export default AssetSeverityIcon
